import {styled} from '@customink/pigment-react/lib/themeCustomink';

const ProductCardImageContainer = styled('a')({
  '&:before': {
    boxShadow: '0px 0px 60px 24px #f5f5f5 inset',
    content: '""',
    inset: 0,
    mixBlendMode: 'darken',
    position: 'absolute'
  },
  '@media (min-width: 43.75em)': {
    flexBasis: 'unset',
    width: '100%'
  },
  borderRadius: '0.5rem',
  display: 'flex',
  flexBasis: '40%',
  flexDirection: 'column',
  overflow: 'hidden',
  position: 'relative',
  transitionDuration: '150ms'
});

export default ProductCardImageContainer;
